import styled from "styled-components";

const UnitelPortalSignupPageDisplay = styled.div`
  background: ${(p) => p.bgImg};
  background-size: cover;

  .gamezoneSignup {
    background: rgb(238 90 17);
  }

  .header_gamezone {
    margin-top: 5px !important;
    width: 100%;
    border-bottom: 2px solid #65378b;
  }

  .links-Section {
    position: relative;
    top: auto;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    padding: 12px 0 24px;
    box-sizing: border-box;
  }

  .links-SectionGamezone {
    top: auto !important;
    width: 100%;

    .play {
      background: var(--play) center center no-repeat;
      height: 164px;
      background-size: contain !important;
      margin: 0 auto 8px;
    }

    .gamezoneInput {
      background: white;
      color: black;
      padding: 10px 12px;
      border: none;
      outline: none;
      border-radius: 8px;
      font-size: 1rem;
      box-sizing: border-box;
      width: 100%;
    }
  }

  .unitel-form-wrap {
    width: 100%;
    max-width: 340px;
    margin: 12px auto 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }

  .unitel-phone-row {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 6px;
    direction: ltr;
  }

  .unitel-keyph {
    width: 72px;
    flex: 0 0 72px;
    text-align: center;
  }

  .unitel-numph {
    flex: 1;
    min-width: 0;
    text-align: left;
  }

  .he-msisdn {
    margin: 8px 0 0;
    font-size: 1.05rem;
    font-weight: 600;
    letter-spacing: 0.3px;
    direction: ltr;
  }

  .links-Section a {
    color: white;
  }

  .links-SectionGamezone button {
    display: block;
    width: 100%;
    margin: 0 auto;
    min-width: 0;
  }

  .formsLayout {
    margin: 0 16px;
    padding-bottom: 24px;

    .gamezoneLogo {
      max-width: 163px !important;
    }

    .header {
      margin-top: 24px;

      .logo {
        background: var(--navbarLogo) center center no-repeat;
        height: var(--loginLogoHeight);
        width: var(--loginLogoWidth);
        max-width: 350px;
        background-size: var(--background-size);
        margin-left: 0;
      }
    }

    .footer .ncellTos {
      font-size: 13px;
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .price-note {
    display: block;
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.35;
  }

  .success-box {
    max-width: 340px;
    margin: 24px auto;
    padding: 16px;
    text-align: center;
    background: rgba(255, 255, 255, 0.12);
    border-radius: 10px;
  }

  @media (max-width: 576px) {
    .links-SectionGamezone .play {
      height: 140px;
    }

    .unitel-keyph {
      width: 64px;
      flex: 0 0 64px;
    }
  }
`;

export default UnitelPortalSignupPageDisplay;
